import React from "react";
import BootstrapDropdown from 'react-bootstrap/Dropdown';
import styles from "./Dropdown.module.scss";

const Dropdown = props => {
  return <div className={`${props.className ? props.className : ''}`}>
    {props.title ? <h3 className={styles.title}>{props.title}</h3> : null}
    <BootstrapDropdown>
      <BootstrapDropdown.Toggle id={props.id} bsPrefix={`dropdown-toggle ${styles.dropdown}`}>
        {props.value && props.value.label ? props.value.label : ''}
      </BootstrapDropdown.Toggle>
      <BootstrapDropdown.Menu>
        {props.options.map(option => <BootstrapDropdown.Item
          bsPrefix={`dropdown-item ${styles.dropdownItem}`}
          onClick={() => props.onSelect(option)}
        >{option.label}</BootstrapDropdown.Item>)}
      </BootstrapDropdown.Menu>
    </BootstrapDropdown>
  </div>
}

export default Dropdown;
